/* Suchleiste: zeigt beim Antippen die Bestseller-Liste, solange das Feld leer
   ist. Sobald getippt wird, verschwindet sie - gesucht wird wie bisher mit
   der Eingabetaste bzw. dem Knopf. */
(function(){
  document.querySelectorAll('[data-kani-suche]').forEach(function(form){
    var feld = form.querySelector('input[type="search"]');
    var liste = form.querySelector('[data-kani-suche-liste]');
    if (!feld || !liste || !liste.querySelector('li')) return;

    function zeigen(){
      if (feld.value.trim() !== '') return schliessen();
      liste.hidden = false;
      feld.setAttribute('aria-expanded', 'true');
    }
    function schliessen(){
      liste.hidden = true;
      feld.setAttribute('aria-expanded', 'false');
    }

    feld.addEventListener('focus', zeigen);
    feld.addEventListener('click', zeigen);
    feld.addEventListener('input', zeigen);
    form.addEventListener('submit', schliessen);

    feld.addEventListener('keydown', function(e){
      if (e.key === 'Escape') schliessen();
    });
    liste.addEventListener('keydown', function(e){
      if (e.key === 'Escape') { schliessen(); feld.focus(); }
    });

    /* Geschlossen wird ueber einen Tipp ausserhalb, nicht ueber blur: iOS
       Safari nimmt Links beim Antippen nicht in den Fokus, das Feld verliert
       ihn also schon vor dem Klick - die Liste waere weg, bevor der Link
       ausgeloest wird. */
    document.addEventListener('pointerdown', function(e){
      if (!liste.hidden && !form.contains(e.target)) schliessen();
    });
    /* Tastatur: mit Tab aus dem Formular heraus schliesst ebenfalls. */
    form.addEventListener('focusout', function(e){
      if (e.relatedTarget && !form.contains(e.relatedTarget)) schliessen();
    });
  });
})();


/* Suchfenster (Handy), siehe sections/kani-suche.liquid. Auf- und
   zugeklappt wird es von kani-klapp.js; hier nur, was die Suche braucht:
   Lupe verbinden, Fokus ins Feld (dann oeffnet iOS die Tastatur), leere
   Suche nicht abschicken. */
(function(){
  var fenster = document.getElementById('kani-suchfenster');
  var lupen = document.querySelectorAll('[data-kani-lupe]');
  if (!fenster || !lupen.length || !window.KaniKlapp) return;
  var feld = fenster.querySelector('[data-kani-sf-feld]');

  lupen.forEach(function(lupe){
    lupe.addEventListener('click', function(){
      KaniKlapp.oeffnen(fenster, lupe, { fokus: feld });
    });
  });

  fenster.querySelector('form').addEventListener('submit', function(e){
    if (feld.value.trim() === '') { e.preventDefault(); return; }
    KaniKlapp.verlassen();
  });
})();
